<template>
    <div
      v-if="!$parent.isPlazaMode"
      class="center-content"
      :class="{
        'agent-mode': $parent.selectedAgent,
        'center-collapsed': $parent.clawMode === 'digital',
      }"
    >
      <!-- 智擎初始化中：显示 loading，避免中间状态闪烁 -->
      <div v-if="$parent.isSmartMode && !$parent.smartPlatformReady" class="center-loading">
        <i class="el-icon-loading"></i>
        <span>{{ $t("workbench.loading") }}</span>
      </div>
      <template v-else>
        <div v-if="$parent.selectedAgent" class="agent-view">
          <template v-if="$parent.selectedDisplayType === 'iframe'">
            <iframe
              class="agent-iframe"
              :src="$parent.selectedIframeSrc"
              frameborder="0"
            ></iframe>
          </template>
          <template v-else-if="$parent.agentChatStarted">
            <CosmoClawChat ref="selectedAgentChat" :isAgent="true" @new-session="$parent.handleAgentNewSession" />
          </template>
          <template v-else-if="$parent.selectedAgent === 'zhi_biao_ding_yi_zhi_neng_ti'">
            <IndicatorAgent />
          </template>
          <template v-else-if="$parent.selectedAgent === 'she_bei_guan_li_zhi_neng_ti'">
            <EmaAgent />
          </template>
          <template v-else-if="$parent.selectedAgent === 'ben_ti_zhi_li_zhi_neng_ti'">
            <GovernanceAgent />
          </template>
          <template v-else-if="$parent.selectedAgent === 'jing_ying_jue_ce_zhi_neng_ti'">
            <DecisionAgent />
          </template>
          <template v-else>
            <div class="agent-cards-wrapper">
              <div class="agent-header" v-if="$parent.agentInfo">
                <div class="agent-header-icon" v-if="$parent.agentInfo.logo">
                  <img :src="$parent.agentInfo.logo" alt="" />
                </div>
                <h3 class="agent-header-title">
                  {{ $t("workbench." + $parent.agentInfo.titleKey) }}
                </h3>
                <p class="agent-header-desc">
                  {{ $t("workbench." + $parent.agentInfo.descKey) }}
                </p>
              </div>
              <div class="agent-cards">
                <div
                  class="sidebar-card"
                  :class="{ active: $parent.selectedCardId === item.id }"
                  v-for="card in $parent.agentCards"
                  :key="card.titleKey"
                  @click="$parent.handleCardClick(card)"
                >
                  <div class="card-icon"><i :class="card.icon"></i></div>
                  <div class="sidebar-card-content">
                    <h4>{{ $t("workbench." + card.titleKey) }}</h4>
                    <p>{{ $t("workbench." + card.descKey) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="agent-input-area">
              <CosmoClawInput ref="cosmoClawInput" />
            </div>
          </template>
        </div>
        <div
          v-else
          class="center-scroll"
          :class="{
            'scroll-active': isScrollHover,
            'classic-mode': !$parent.isSmartMode,
            [`active-tab-${$parent.activeTabId}`]: true,
            'active-cfo-tool-tab': $parent.isCfoToolTab,
            'active-business-report-tab': $parent.isBusinessReportTab,
            'active-price-management-tab': $parent.activeTabId === 'price-management',
          }"
          @mouseenter="isScrollHover = true"
          @mouseleave="isScrollHover = false"
        >
          <div
            class="workbench-tabs-wrap"
            :class="{ 'has-more': tabsOverflowMore }"
            v-if="$parent.workbenchTabs.length > 0 && !$parent.isPlazaMode && !$parent.selectedAgent"
          >
            <div
              ref="workbenchTabs"
              class="workbench-tabs"
              @scroll="checkTabsOverflow"
            >
              <div
                v-for="(tab, index) in $parent.workbenchTabs"
                :key="tab.id"
                class="workbench-tab"
                :class="{ active: $parent.activeTabId === tab.id }"
                @click="$parent.handleTabClick(tab)"
              >
                <span class="tab-title">{{ tab.title }}</span>
                <i
                  v-if="tab.closable"
                  class="el-icon-close tab-close"
                  @click.stop="$parent.handleTabClose(index)"
                ></i>
              </div>
            </div>
          </div>
          <div
            class="workbench-content flex-1"
            :class="{ 'cfo-workbench-content': $parent.isCfoWorkbench }"
          >
            <component
              :is="$parent.currentComponent"
              @smart-analysis="$parent.handleSmartAnalysis"
              @open-detail="$parent.handleOpenDetail"
              @open-list="$parent.handleOpenList"
              @task-open-detail="$parent.handleTaskOpenDetail"
              @task-open-list="$parent.handleTaskOpenList"
              @decision-open-detail="$parent.handleDecisionOpenDetail"
              @decision-open-list="$parent.handleDecisionOpenList"
              @open-tool="$parent.handleOpenCfoTool"
              @start-chat="$parent.handleWarRoomStartChat"
              @open-price-management="$parent.handleOpenPriceManagement"
            />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'detail'">
            <EnterpriseDetail
              :id="$parent.currentReportId"
              :report-source="$parent.currentReportSource"
            />
          </div>
          <div class="list-panel flex-1" v-if="$parent.activeTabId === 'list'">
            <EnterpriseList
              :agentId="$parent.currentAgentId"
              @open-detail="$parent.handleOpenDetailFromList"
              @smart-analysis="$parent.handleSmartAnalysis"
            />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'task-detail'">
            <TaskDetail :id="$parent.currentTaskDetailId" />
          </div>
          <div class="list-panel flex-1" v-if="$parent.activeTabId === 'task-list'">
            <TaskList
              :agentId="$parent.currentAgentId"
              @open-detail="$parent.handleTaskOpenDetail"
              @view-detail="$parent.handleViewTaskReport"
              @view-task-detail="$parent.handleTaskOpenDetail"
            />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'decision-detail'">
            <DecisionDetail :id="$parent.currentDecisionId" />
          </div>
          <div class="list-panel flex-1" v-if="$parent.activeTabId === 'decision-list'">
            <DecisionList
              :reviewerAgentId="$parent.currentAgentId"
              @open-detail="$parent.handleDecisionOpenDetail"
              @smart-analysis="$parent.handleSmartAnalysis"
            />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'e2e-report'">
            <E2EReport />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'cfo-report'">
            <CfoReport />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'industry-report'">
            <IndustryReport />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'chain-report'">
            <ChainReport />
          </div>
          <div class="detail-panel flex-1 price-management-panel" v-if="$parent.activeTabId === 'price-management'">
            <PriceIncreaseManagement />
          </div>
          <div class="detail-panel flex-1 preference-panel" v-if="$parent.activeTabId === 'preference'">
            <SupplyChainPreference @back="$parent.handleTabClose($parent.workbenchTabs.findIndex(t => t.id === 'preference'))" />
          </div>
          <div class="detail-panel flex-1 cfo-tool-panel" v-if="$parent.isCfoToolTab">
            <CfoToolPanel :tool-id="$parent.activeTabId" />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.isBusinessReportTab">
            <BusinessReportViewer :report-key="$parent.activeTabId" />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'report-history'">
            <CfoReportHistory />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'task-queue-all'">
            <CfoTaskQueueHistory />
          </div>
          <div class="detail-panel flex-1" v-if="$parent.activeTabId === 'decisions-all'">
            <CfoDecisionsHistory />
          </div>
          <div
            class="detail-panel flex-1 history-report-detail"
            v-if="$parent.activeTabId === 'history-report-detail'"
          >
            <div class="history-report-header">
              <div class="download-btn" @click="$parent.handleHistoryReportDownload">
                <img src="@/assets/imgs/detail/download_icon.png" alt="" width="16" height="16">
                下载
              </div>
              <div class="view-switch" :class="{ 'mode-web': $parent.historyReportViewMode === 'web', 'mode-doc': $parent.historyReportViewMode === 'doc' }">
                <div style="font-size: 12px" class="switch-tab tab-web" @click="$parent.historyReportViewMode = 'web'">网页</div>
                <div style="font-size: 12px" class="switch-tab tab-doc" @click="$parent.historyReportViewMode = 'doc'">文档</div>
              </div>
            </div>
            <div ref="historyPdfContent">
              <div v-if="$parent.historyReportViewMode === 'doc' && $parent.currentHistoryReportContent" class="markdown-body">
                <div v-html="$parent.renderMarkdownText($parent.currentHistoryReportContent)"></div>
              </div>
              <!-- 网页模式：大模型生成的 HTML 经 DOMPurify 净化并挂入 Shadow DOM，隔离样式与脚本 -->
              <SafeHtmlRenderer
                v-else-if="$parent.historyReportViewMode === 'web' && $parent.currentHistoryReportHtml"
                class="html-body"
                :html="$parent.currentHistoryReportHtml"
                @rendered="$parent.onHistoryReportSafeHtmlRendered"
              />
            </div>
          </div>
          <div
            class="detail-panel flex-1"
            v-if="$parent.activeTabId === 'center-iframe' && $parent.centerIframeItem"
          >
            <CenterIframe :url="$parent.centerIframeItem.url" :name="$parent.centerIframeItem.name" />
          </div>
        </div>
      </template>
    </div>
</template>

<script>
import CosmoClawChat from './CosmoClawChat.vue'
import CosmoClawInput from './CosmoClawInput.vue'
import CenterIframe from './CenterIframe.vue'
import IndicatorAgent from '../agents/IndicatorAgent.vue'
import GovernanceAgent from '../agents/GovernanceAgent.vue'
import DecisionAgent from '../agents/DecisionAgent.vue'
import EmaAgent from '../agents/EmaAgent.vue'
import EnterpriseDetail from '@/views/workbench/components/EnterpriseDetail.vue'
import EnterpriseList from '@/views/workbench/components/EnterpriseList.vue'
import TaskList from '@/views/workbench/components/TaskList.vue'
import TaskDetail from '@/views/workbench/components/TaskDetail.vue'
import DecisionList from '@/views/workbench/components/DecisionList.vue'
import DecisionDetail from '@/views/workbench/components/DecisionDetail.vue'
import E2EReport from '@/views/smart-workbench/components/E2EReport.vue'
import CfoReport from '@/views/smart-workbench/components/CfoReport.vue'
import CfoReportHistory from '@/views/workbench/cfo/components/CfoReportHistory.vue'
import IndustryReport from '@/views/smart-workbench/components/IndustryReport.vue'
import ChainReport from '@/views/smart-workbench/components/ChainReport.vue'
import CfoTaskQueueHistory from '@/views/workbench/cfo/components/CfoTaskQueueHistory.vue'
import CfoDecisionsHistory from '@/views/workbench/cfo/components/CfoDecisionsHistory.vue'
import CfoToolPanel from '@/views/workbench/cfo/tools/CfoToolPanel.vue'
import BusinessReportViewer from '@/views/smart-workbench/components/BusinessReportViewer.vue'
import PriceIncreaseManagement from '@/views/workbench/cso/PriceIncreaseManagement.vue'
import SupplyChainPreference from '@/views/smart-workbench/components/SupplyChainPreference.vue'
import SafeHtmlRenderer from '@/components/SafeHtmlRenderer/index.vue'
export default {
  name: 'CenterContent',
  components: {
    CosmoClawChat,
    CosmoClawInput,
    CenterIframe,
    IndicatorAgent,
    GovernanceAgent,
    DecisionAgent,
    EmaAgent,
    EnterpriseDetail,
    EnterpriseList,
    TaskList,
    TaskDetail,
    DecisionList,
    DecisionDetail,
    E2EReport,
    CfoReport,
    IndustryReport,
    ChainReport,
    CfoReportHistory,
    CfoTaskQueueHistory,
    CfoDecisionsHistory,
    CfoToolPanel,
    BusinessReportViewer,
    PriceIncreaseManagement,
    SupplyChainPreference,
    SafeHtmlRenderer
  },
  data() {
    return {
      isScrollHover: false,
      tabsOverflowMore: false
    }
  },
  computed: {
    tabCount() {
      return this.$parent.workbenchTabs ? this.$parent.workbenchTabs.length : 0
    }
  },
  watch: {
    tabCount() {
      this.$nextTick(() => this.checkTabsOverflow())
    }
  },
  methods: {
    checkTabsOverflow() {
      const el = this.$refs.workbenchTabs
      if (!el) {
        this.tabsOverflowMore = false
        return
      }
      this.tabsOverflowMore =
        el.scrollWidth > el.clientWidth + 1 &&
        el.scrollLeft + el.clientWidth < el.scrollWidth - 1
    }
  },
  mounted() {
    this.$nextTick(() => this.checkTabsOverflow())
    window.addEventListener('resize', this.checkTabsOverflow)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkTabsOverflow)
  }
}
</script>

<style lang="scss" scoped>
.flex-1 {
  flex: 1;
  overflow: hidden;
}

.sidebar-card {
  width: 100%;
  height: 64px;
  background: #ffffff;
  border: 1px solid #edf1fb;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  box-sizing: border-box;
}

.sidebar-card:hover,
.sidebar-card.active {
  background-image: linear-gradient(90deg, #d7dbfd 0%, #f6f7ff 23%, #dbdffd 100%);
  box-shadow: inset 0 0 8px 0 #ffffff;
}

.sidebar-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 8px;
  padding: 1px;
  background: linear-gradient(-49deg, #7a63fe 0%, #4a64f4 33%, #4d7efd 66%, #4eb9ff 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.sidebar-card:hover::before,
.sidebar-card.active::before {
  opacity: 1;
}

.sidebar-card.disabled {
  cursor: default;
  opacity: 0.6;
}

.sidebar-card.disabled:hover {
  border-color: #edf1fb;
  box-shadow: none;
}

/* ========== 中间内容区 ========== */
.center-content {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  transition: width 0.4s ease, opacity 0.35s ease, padding 0.4s ease, margin 0.4s ease;
}

.center-loading {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #86909c;
  font-size: 14px;
}
.center-loading .el-icon-loading {
  font-size: 18px;
}

.center-content.center-collapsed {
  width: 0;
  min-width: 0;
  opacity: 0;
  padding: 0;
  margin: 0;
  pointer-events: none;
}

.agent-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  border: 1px solid #ffffff;
  overflow: hidden;
  margin-left: 16px;
}

.agent-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.agent-cards-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
}

.agent-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;

  .agent-header-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4a5ff3 0%, #7b61ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    box-shadow: 0 6px 20px rgba(74, 95, 243, 0.3);

    img {
      width: 36px;
      height: 36px;
    }
  }

  .agent-header-title {
    margin: 0 0 8px 0;
    font-size: 22px;
    font-weight: 700;
    color: #1f2329;
    letter-spacing: 1px;
  }

  .agent-header-desc {
    margin: 0;
    font-size: 14px;
    color: #646a73;
    line-height: 1.8;
    text-align: center;
    max-width: 800px;
  }
}

.agent-input-area {
  max-width: 1020px;
  width: 100%;
  margin: 0 auto;
}

.agent-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  max-width: 960px;
  width: 100%;
}

.agent-card {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  .card-icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    background: #eef2ff;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 20px;
      color: #4a5ff3;
    }
  }

  .sidebar-card-content {
    flex: 1;
    min-width: 0;

    h4 {
      margin: 0 0 4px 0;
      font-size: 14px;
      font-weight: 600;
      color: #1f2329;
    }

    p {
      margin: 0;
      font-size: 12px;
      color: #646a73;
    }
  }
}

.center-scroll {
  flex: 1;
  // overflow-y: auto;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #ffffff;
  border-right: none;
  padding: 10px;
  padding-right: 16px;
  padding-left: 22px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.center-scroll:hover {
  scrollbar-color: rgba(148, 163, 184, 0.5) transparent;
}

.center-scroll::-webkit-scrollbar {
  width: 4px;
}

.center-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.center-scroll::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

.center-scroll:hover::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.5);
}

.center-scroll.classic-mode {
  border-radius: 8px;
}

.workbench-tabs-wrap {
  position: relative;
  min-width: 0;
  margin-bottom: 16px;
}
.workbench-tabs {
  display: flex;
  gap: 4px;
  padding-bottom: 8px;
  overflow-x: auto;
  white-space: nowrap;
  flex-wrap: nowrap;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
// .workbench-tabs-wrap.has-more::after {
//   content: "";
//   position: absolute;
//   top: 0;
//   right: 0;
//   height: 31px;
//   width: 20px;
//   pointer-events: none;
//   background:
//     linear-gradient(270deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0) 100%),
//     linear-gradient(270deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 100%);
// }
.workbench-tabs:hover {
  scrollbar-color: rgba(148, 163, 184, 0.5) transparent;
}
.workbench-tabs::-webkit-scrollbar {
  height: 2px;
}
.workbench-tabs::-webkit-scrollbar-track {
  background: transparent;
}
.workbench-tabs::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 2px;
}
.workbench-tabs:hover::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.5);
}

.workbench-tab {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  line-height: 1;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #595959;

  &:hover {
    background: rgba(255, 255, 255, 0.8);
  }

  &.active {
    // background: #fff;
    background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
    // color: #fff;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);

    .tab-title {
      color: #fff;
    }

    .tab-close {
      color: #fff;
    }
  }
}

.tab-title {
  font-size: 13px;
  color: #666;
  font-family: PingFangSC-Regular;
}

.workbench-tab.active .tab-title {
  // color: #333;
  // font-weight: 600;
  // color: #fff;
}

.tab-close {
  font-size: 12px;
  color: #999;
  // &:hover {
  //   color: #F44336;
  // }
}

.workbench-content {
  display: none;
  overflow-x: hidden;

  &.active {
    display: block;
  }
}

.workbench-content.cfo-workbench-content {
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(37, 99, 235, 0.28) transparent;
}

.workbench-content.cfo-workbench-content::-webkit-scrollbar {
  height: 8px;
}

.workbench-content.cfo-workbench-content::-webkit-scrollbar-track {
  background: transparent;
}

.workbench-content.cfo-workbench-content::-webkit-scrollbar-thumb {
  background: rgba(37, 99, 235, 0.28);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.detail-panel,
.list-panel {
  display: none;
  padding: 0;
  height: 100%;
  min-height: 0;
  overflow: hidden;

  &.active {
    display: block;
  }
}

.active-tab-workbench .workbench-content {
  display: block;
}

.active-tab-detail .detail-panel {
  display: block;
}

.active-tab-preference .detail-panel {
  display: block;
}

.active-tab-list .list-panel {
  display: block;
}

.center-scroll.active-tab-workbench .workbench-content {
  display: block;
}

.center-scroll.active-tab-detail .detail-panel {
  display: block;
}

.center-scroll.active-tab-list .list-panel {
  display: block;
}

.center-scroll.active-tab-detail .workbench-content,
.center-scroll.active-tab-list .workbench-content,
.center-scroll.active-tab-task-detail .workbench-content,
.center-scroll.active-tab-task-list .workbench-content,
.center-scroll.active-tab-decision-detail .workbench-content,
.center-scroll.active-tab-decision-list .workbench-content,
.center-scroll.active-tab-e2e-report .workbench-content,
.center-scroll.active-tab-cfo-report .workbench-content,
.center-scroll.active-tab-report-history .workbench-content,
.center-scroll.active-tab-task-queue-all .workbench-content,
.center-scroll.active-tab-decisions-all .workbench-content,
.center-scroll.active-tab-center-iframe .workbench-content,
.center-scroll.active-cfo-tool-tab .workbench-content,
.center-scroll.active-business-report-tab .workbench-content,
.center-scroll.active-tab-preference .workbench-content {
  display: none;
}

.center-scroll.active-price-management-tab .workbench-content {
  display: none;
}

.center-scroll.active-price-management-tab .detail-panel {
  display: block;
}

.price-management-panel {
  min-height: 0;
  overflow: hidden;
}

.preference-panel {
  min-height: 0;
  overflow: hidden;
}

.center-scroll.active-tab-preference .detail-panel {
  display: block;
  overflow-y: auto;
}

.center-scroll.active-tab-task-detail .detail-panel {
  display: block;
  // overflow-y: auto;
}

.center-scroll.active-tab-task-list .list-panel {
  display: block;
}

.center-scroll.active-tab-decision-detail .detail-panel {
  display: block;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 2px;
  }
}

.center-scroll.active-tab-decision-list .list-panel {
  display: block;
}

.center-scroll.active-tab-e2e-report .detail-panel {
  display: block;
}

.center-scroll.active-tab-cfo-report .detail-panel {
  display: block;
}

.center-scroll.active-tab-report-history .detail-panel {
  display: block;
}

.center-scroll.active-tab-task-queue-all .detail-panel {
  display: block;
}

.center-scroll.active-tab-decisions-all .detail-panel {
  display: block;
}

.center-scroll.active-cfo-tool-tab .cfo-tool-panel {
  display: block;
  min-width: 1000px;
}

.center-scroll.active-cfo-tool-tab {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(37, 99, 235, 0.28) transparent;
}

.center-scroll.active-cfo-tool-tab::-webkit-scrollbar {
  height: 8px;
}

.center-scroll.active-cfo-tool-tab::-webkit-scrollbar-thumb {
  background: rgba(37, 99, 235, 0.28);
  border-radius: 999px;
}

.center-scroll.active-business-report-tab .detail-panel {
  display: block;
  min-width: 800px;
}

.center-scroll.active-business-report-tab {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(37, 99, 235, 0.28) transparent;
}

.center-scroll.active-business-report-tab::-webkit-scrollbar {
  height: 8px;
}

.center-scroll.active-business-report-tab::-webkit-scrollbar-thumb {
  background: rgba(37, 99, 235, 0.28);
  border-radius: 999px;
}

.center-scroll.active-tab-history-report-detail .detail-panel {
  display: block;
}

.center-scroll.active-tab-history-report-detail .workbench-content {
  display: none;
}

.center-scroll.active-tab-center-iframe .detail-panel {
  display: flex;
  flex-direction: column;
}

.history-report-detail {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 2px;
  }
}

.history-report-detail .markdown-body {
  font-size: 12px;
  color: #333;
  line-height: 1.85;
}

.history-report-detail .markdown-body ::v-deep h1 {
  margin: 24px 0 12px;
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 600;
}

.history-report-detail .markdown-body ::v-deep h2 {
  margin: 20px 0 10px;
  color: #1a1a1a;
  font-size: 15px;
  font-weight: 600;
}

.history-report-detail .markdown-body ::v-deep h3 {
  margin: 16px 0 8px;
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 600;
}

.history-report-detail .markdown-body ::v-deep h4,
.history-report-detail .markdown-body ::v-deep h5,
.history-report-detail .markdown-body ::v-deep h6 {
  margin: 12px 0 6px;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 600;
}

.history-report-detail .markdown-body ::v-deep table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
  font-size: 12px;
}

.history-report-detail .markdown-body ::v-deep th,
.history-report-detail .markdown-body ::v-deep td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  text-align: left;
  font-size: 12px;
}

.history-report-detail .markdown-body ::v-deep th {
  background: #f5f6f8;
  font-weight: 600;
}

.history-report-detail .markdown-body ::v-deep p {
  margin: 8px 0;
  line-height: 1.85;
  font-size: 12px;
}

.history-report-detail .markdown-body ::v-deep ul,
.history-report-detail .markdown-body ::v-deep ol {
  padding-left: 20px;
  margin-bottom: 12px;
  font-size: 12px;
}

.history-report-detail .markdown-body ::v-deep li {
  line-height: 2.0;
  margin: 6px 0;
  font-size: 12px;
}

.history-report-detail .markdown-body ::v-deep strong {
  font-weight: 600;
}

.history-report-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  /* 滚动时头部固定：与经营分析页保持一致 */
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  /* 负 margin 抵消容器 24px 内边距，让白底横向铺满并覆盖顶部圆角 */
  margin: -24px -24px 20px;
  padding: 24px 24px 12px;
  border-radius: 8px 8px 0 0;
}

.history-report-detail .view-switch {
  display: inline-flex;
  height: 24px;
  position: relative;
  border-radius: 4px;
  overflow: visible;
}

.history-report-detail .switch-tab {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  transition: all 0.25s ease;
  position: relative;
}

.history-report-detail .switch-tab.tab-web {
  background: #eef4ff;
  color: #666;
  clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
  border-radius: 4px 0 0 4px;
}

.history-report-detail .switch-tab.tab-doc {
  background: #eef4ff;
  color: #666;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0 100%);
  border-radius: 0 4px 4px 0;
  margin-left: -6px;
}

.history-report-detail .view-switch.mode-web .tab-web {
  background: #4a5ff3;
  color: #fff;
  z-index: 1;
}

.history-report-detail .view-switch.mode-web .tab-doc {
  background: #f5f7fa;
  color: #999;
}

.history-report-detail .view-switch.mode-doc .tab-doc {
  background: #4a5ff3;
  color: #fff;
  z-index: 1;
}

.history-report-detail .view-switch.mode-doc .tab-web {
  background: #f5f7fa;
  color: #999;
}

.history-report-detail .download-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 4px;
  color: #4A5FF3;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  width: 72px;
  height: 24px;
  border: 1px solid #4A5FF3;
  border-radius: 4px;
}

.history-report-detail .html-body {
  line-height: 1.8;
  color: #333;
  font-size: 14px;
}

/* shared .sidebar-card responsive sizing (agent cards) */
@media screen and (max-width: 1559px) {
  .sidebar-card {
    height: 60px;
    padding: 10px;
    gap: 10px;
  }
}
@media screen and (max-width: 1439px) {
  .sidebar-card {
    height: 56px;
    padding: 8px;
    gap: 8px;
  }
}
@media screen and (max-width: 1279px) {
  .sidebar-card {
    height: 50px;
    padding: 6px;
    gap: 6px;
  }
}
</style>
